var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px" } },
    [
      _c("div", { staticClass: "title" }, [_vm._v("淘礼金推广位管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "account_box",
          staticStyle: {
            background: "#fff",
            padding: "30px",
            "border-radius": "20px",
          },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "180px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "淘宝开放平台App Key", prop: "appKey" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "70%" },
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.ruleForm.appKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "appKey", $$v)
                          },
                          expression: "ruleForm.appKey",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "淘宝开放平台App Secret",
                        prop: "appSecret",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "70%" },
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.ruleForm.appSecret,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "appSecret", $$v)
                          },
                          expression: "ruleForm.appSecret",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推广位pid", prop: "pid" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "70%" },
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.ruleForm.pid,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "pid", $$v)
                          },
                          expression: "ruleForm.pid",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          padding: "10px 10px 10px 20px",
          "line-height": "26px",
          color: "#f59a23",
          background: "#fdf6ec",
          "border-radius": "8px",
        },
      },
      [
        _c("div", [
          _vm._v(
            "1. App 上线淘礼金功能前，需提前获取淘宝联盟的淘礼金功能权限，并在淘宝开放平台创建好对应应用！"
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "2. 需将淘宝开放平台应用的 App Key / App Secret 配置到当前功能，并添加该应用对应淘宝联盟账号下的推广位 PID；配置不全将导致无法创建商品礼金红包。"
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "3. 淘礼金所使用的推广位 PID，必须为淘礼金专属，不能与平台其他业务（如联盟配置、礼金补贴活动等）使用的 PID 重复。"
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "4. 淘礼金的配置与平台日常转链 / 返利业务相互独立，支持对接不同的淘宝联盟账号，不影响现有业务运行。"
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }